import { REMOVER_FILTRO_CTE_OS } from '../types'

export default function removerFiltroCteOs (filtro) {
  return {
    payload: filtro,
    type: REMOVER_FILTRO_CTE_OS
  }
}
